import type { SVGProps } from 'react';

const SvgWait = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={28}
    viewBox='0 0 35 29'
    width={34}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle cx={14} cy={14} fill='#FFC84D' r={14} transform='matrix(-1 0 0 1 28.883 .92)' />
    <path
      d='M21.038 11.02c-.154-.984.104-1.842.578-1.916.473-.074.982.663 1.136 1.646.154.984-.104 1.841-.578 1.916-.473.074-.982-.663-1.136-1.647Z'
      fill='#000'
    />
    <path d='M6.691 13.282a6.825 6.825 0 1 1 13.65 0 6.825 6.825 0 0 1-13.65 0Z' fill='#D9D9D9' />
    <path
      d='M7.576 16.232c2.905-2.97 8.754-8.907 8.908-8.907l-1.905-.507-4.721 1.236-2.471 2.827.19 5.35Z'
      fill='#E9E9E9'
    />
    <path
      d='M15.777 12.255c-.188-1.199.128-2.244.705-2.335.577-.09 1.197.808 1.385 2.007.188 1.199-.128 2.244-.705 2.334-.577.09-1.197-.808-1.385-2.006Z'
      fill='#000'
    />
    <path
      d='M7.376 13.282a6.14 6.14 0 1 1 12.28 0 6.14 6.14 0 0 1-12.28 0Z'
      stroke='#fff'
      strokeWidth={1.369}
    />
    <path
      d='M28.883 16.92c-1.41 0-2.715.495-3.75 1.32a5.956 5.956 0 0 0-2.25 4.68c0 1.125.315 2.19.87 3.09a5.955 5.955 0 0 0 5.13 2.91 5.858 5.858 0 0 0 3.945-1.5c.465-.39.87-.87 1.185-1.41.555-.9.87-1.965.87-3.09 0-3.315-2.685-6-6-6Zm3.105 5.355-3.195 2.955c-.21.195-.495.3-.765.3-.285 0-.57-.105-.795-.33l-1.485-1.485a1.132 1.132 0 0 1 0-1.59 1.132 1.132 0 0 1 1.59 0l.72.72 2.4-2.22c.45-.42 1.17-.39 1.59.06.42.45.39 1.155-.06 1.59Z'
      fill='#3889FF'
    />
  </svg>
);
export default SvgWait;
